<template>
    <div class="flex flex-col justify-end items-center bg-gray-50 content-section-rounded-top min-h-3.5">
        <div class="flex flex-row justify-center absolute top-[0.5px] left-2.5 right-1.5 z-10">
            <slot />
        </div>
    </div>
</template>

<style scoped>
.content-section-rounded-top {
    position: relative;
}

.content-section-rounded-top::before {
    position: absolute;
    height: 0.25rem;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: var(--color-gray-50);
    z-index: 10;
    content: '';
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
</style>
